import { BlueprintApiResponse } from "@sourceful/shared-types";
import { wait } from "./wait";

export const pollForFingerprints = async (
  pollFunc: Function,
  waitTime: number = 10000
): Promise<BlueprintApiResponse> => {
  let result: BlueprintApiResponse = await pollFunc();
  while (!result.ready) {
    await wait(waitTime);
    result = await pollFunc();
  }
  return result;
};
